import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import ResizeObserver from 'resize-observer-polyfill';

import React from 'react'
import ReactDOM from 'react-dom'
import { createStore, applyMiddleware, compose } from 'redux'
import App from './containers/App'
import reducer from './reducers'
import * as actions from './actions'
import { Provider } from 'react-redux'
import thunkMiddleware from 'redux-thunk'
import * as immer from 'immer';
import { sendParentLoaded, sendParentResize, setParentOrigin, handleParentMessage } from './parentCommunication';
import { ALLOWED_URL_MODES, AppMode } from './constants';

import './index.css'

immer.enableMapSet();

const composeEnhancers = (process.env.NODE_ENV === 'development' && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
export const store = createStore(reducer, composeEnhancers(applyMiddleware(thunkMiddleware)));
const dispatch = store.dispatch as actions.Dispatch;
const promise = dispatch(actions.loadJSON(process.env.PUBLIC_URL + '/rynny-config.json', actions.CONFIG_JSON))
	.then(() => {
		const state = store.getState()

		const urlParams = new URLSearchParams(window.location.search);
		const mode = urlParams.get('mode');
		if (typeof mode === 'string' && (ALLOWED_URL_MODES as string[]).includes(mode)) {
			dispatch(actions.setAppMode(mode as AppMode));
		}
		const origin = urlParams.get('origin');
		if (typeof mode === 'string') {
			setParentOrigin(origin);
		}
		sendParentLoaded();

		const API_URL = state.config.apiUrl;
    	const route = 'products/downloadGuttersAssortment';
		return dispatch(actions.loadJSON(`${API_URL}${route}`, actions.SYSTEMS_JSON))
	});

(window as any).updateOrder = (order: string) => {
	promise.then(() => {
		if (order && order.length > 0) {
			try {
				order = decodeURIComponent(order);
				order = JSON.parse(order);
				if (order.length > 0) {
					return dispatch(actions.loadOldOrder(order as any));
				}
			} catch (ex) {
				return;
			}
		}
	});
};

(window as any).rynnyMount = (id, order) => {

	const rootEl = document.getElementById(id)

	const render = () => ReactDOM.render(
		<Provider store={store}>
			<App />
		</Provider>,
		rootEl
	)
	render();

	store.subscribe(render)
	promise.then(() => {
		if (order && order !== 'null') {
			try {
				order = decodeURIComponent(order)
				order = JSON.parse(order)
				if (order.length > 0) {
					return dispatch(actions.loadOldOrder(order))
				}
			} catch (ex) {
				return
			}
		}
	})
	.catch(() => {
		store.dispatch(actions.setMessageAction('Błąd przy ładowaniu danych.'))
	})
}

(window as any).rynnyUnmount = (id) => {
	ReactDOM.unmountComponentAtNode(document.getElementById(id))
}

// handle communication with parent window using postMesssage
window.addEventListener('message', handleParentMessage);

window.addEventListener('load', () => {
	new ResizeObserver(() => {
		sendParentResize(getComputedStyle(window.document.body).height);
	}).observe(window.document.body);
});